import React, { useState } from 'react';
import styled from 'astroturf/react';

import { TextButton } from 'js/design_system/TextButton';
import { Body } from 'js/design_system/Body';

const Question = styled(TextButton)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding: 6px 8px;
  height: min-content;

  @include for-tablet-up {
    &:only-child {
      margin-bottom: -12px;
    }
  }
`;

const Answer = styled(Body)`
  padding: 0 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

const WhoCanSeePost: React.FunctionComponent = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <Question onClick={() => setExpanded((v) => !v)}>
        Who can see my post?
      </Question>
      {expanded && (
        <Answer>
          Your followers and profile visitors may see your post on Academia.edu.
          Posts that are interesting or relevant may also be shown to other
          users.
        </Answer>
      )}
    </>
  );
};

export default WhoCanSeePost;
